import classNames from "classnames";
import { useController } from "react-hook-form";
import { TextField } from "../../../components/ui/index.js";

import ComposerParamLabel from "./ComposerParamLabel.js";
import { type ComposerParamComponentProps } from "./index.js";

const ComposerIntegerParam = ({
  control,
  name,
  param,
}: ComposerParamComponentProps<"integer" | "number">) => {
  const { field } = useController({ control, name });

  return (
    <TextField
      type="number"
      inputContainerClassName={classNames("w-36")}
      control={control}
      name={name}
      value={field.value == null ? "" : (field.value as number)}
      label={param.name && <ComposerParamLabel unwrap param={param} />}
      formatDisplayValue={(value) => String(value || "")}
      formatChangeValue={(value) =>
        value === "" || Number.isNaN(+value) ? null : +value
      }
    />
  );
};

export default ComposerIntegerParam;
